export default __webpack_public_path__ + "locales/pt-BR/ChangePortalOwner.json?hash=5ea15b9d6d5b93dbf54aec395cf264de";